import { motion } from "framer-motion";
import { MANIFESTO } from "../data/site";
import { fadeUp, stagger } from "../lib/animations";

export const Manifesto = () => {
  return (
    <section
      id="studio"
      className="relative bg-brand-ink py-24 sm:py-32 overflow-hidden"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="max-w-3xl"
        >
          <span className="text-xs uppercase tracking-[0.22em] font-semibold text-white/40">
            The studio
          </span>
          <h2 className="mt-4 font-heading font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white leading-none">
            Built on a simple belief about learning.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/55">
            The 21st century learns through digital media. We exist to make that
            media rich, interactive and genuinely loved.
          </p>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-16 sm:mt-20 grid md:grid-cols-3 gap-10 md:gap-8"
        >
          {MANIFESTO.map((chapter) => (
            <motion.div
              key={chapter.number}
              variants={fadeUp}
              className="relative pt-14"
              data-testid={`manifesto-${chapter.number}`}
            >
              <span className="pointer-events-none select-none absolute -top-6 -left-2 font-heading font-extrabold text-[7rem] leading-none text-white/[0.06]">
                {chapter.number}
              </span>
              <div className="relative">
                <div className="h-px w-12 bg-brand mb-6" />
                <h3 className="font-heading font-bold text-2xl text-white">
                  {chapter.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-white/55">
                  {chapter.body}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
